module.exports = __webpack_public_path__ + "img/Club-slider5-coatches.a32970aa.png";